/*********************************************************
 * Copyright (C) 2020 VMware, Inc. All rights reserved.
 *********************************************************/

import { Component, Input, Output } from '@angular/core';
import { AbstractModalComponentWithCheckBox } from '../abstract-modal.component.with-checkbox';

@Component({
   selector: 'cancel-confirm-dialog-with-checkbox',
   templateUrl: './cancel-confirm-dialog-with-checkbox.component.html',
   styles: [`
      /deep/ .modal.show .modal-dialog {
         width: 451.89px;
      }
   `]
 })

export class CancelConfirmDialogWithCheckBoxComponent extends AbstractModalComponentWithCheckBox {
   @Input() public title;
   @Input() public message;
   @Input() public buttonLabelConfirm?;
   @Input() public buttonLabelCancel?;
   @Input() public checkboxTitle?;
   @Input() public showCancelButton?;
 }